import useSplitedTableByColumn from '../../../hooks/useSplitedTableByColumn';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const columnLables = {
  january_rate: {
    name: 'January',
    letter: 'A'
  },
  february_rate: {
    name: 'February',
    letter: 'B'
  },
  march_rate: {
    name: 'March',
    letter: 'C'
  },
  april_rate: {
    name: 'April',
    letter: 'D'
  },
  may_rate: {
    name: 'May',
    letter: 'E'
  },
  june_rate: {
    name: 'June',
    letter: 'F'
  },
  july_rate: {
    name: 'July',
    letter: 'G'
  },
  august_rate: {
    name: 'August',
    letter: 'H'
  },
  september_rate: {
    name: 'September',
    letter: 'I'
  },
  october_rate: {
    name: 'October',
    letter: 'J'
  },
  november_rate: {
    name: 'November',
    letter: 'K'
  },
  december_rate: {
    name: 'December',
    letter: 'L'
  }
};

const _tables = [
  {
    name: 'Gross investment returns or IRR over the reporting period (in %, gross of management and performance fees)',
    order: 236,
    columnLables,
    key: 'GROSS'
  },
  {
    name: 'Net investment returns or IRR over the reporting period (in %, net of management and performance fees)',
    order: 237,
    columnLables,
    key: 'NET'
  },
  {
    name: 'Change in Net Asset Value over the reporting period (in %, including the impact of subscriptions and redemptions)',
    order: 238,
    columnLables,
    key: 'NAV_CHANGE'
  },
  {
    name: 'Subscriptions over the reporting period',
    order: 239,
    columnLables,
    key: 'SUBSCRIPTION'
  },
  {
    name: 'Redemptions over the reporting period',
    order: 240,
    columnLables,
    key: 'REDEMPTION'
  }
];

export function HistoricalProfile({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useSplitedTableByColumn({
    data: funds[currentDataKey]?.fund_data?.HISTORICAL_PROFILE,
    onChangeFund,
    schema: schema.HISTORICAL_PROFILE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.HISTORICAL_PROFILE?.field_names || [],
    tableName: 'HISTORICAL_PROFILE',
    tables: _tables,
    isMultiFunds,
    funds
  });

  return (
    <StyledTables id="fca-reporttables-historical-profile-group">
      {tables.map((rows, index) => (
        <Table
          id={`fca-reporttables-historical-profile-table-${index + 1}`}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
          key={index + 'HISTORICAL_PROFILE-2'}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
        />
      ))}
    </StyledTables>
  );
}
